import React from "react";
import { Link } from "react-router-dom";
import { Star, ArrowRight } from "lucide-react";
import { isFestive, XMAS_URL } from "../lib/season";

export const ChristmasFeature = () => {
  if (!isFestive()) return null;
  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-8" data-testid="home-christmas-feature">
      <div className="relative overflow-hidden rounded-sm border border-[#C5A059] bg-[#2D4A3E] text-white p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center gap-5 justify-between">
        <Star className="absolute -right-6 -top-6 w-36 h-36 text-[#C5A059]/25" fill="currentColor" />
        <div className="relative">
          <p className="font-mono-cv text-[11px] uppercase tracking-[0.2em] text-[#E8D5A6]">December special · Trivia Vault</p>
          <h2 className="font-serif-display text-2xl sm:text-3xl font-bold mt-2">Every UK Christmas No.1 since 1952</h2>
          <p className="font-body text-base text-white/80 mt-1">From Al Martino to the sausage-roll era. How many can you name?</p>
        </div>
        <div className="relative flex gap-2 shrink-0">
          <Link to={XMAS_URL} data-testid="home-christmas-play" className="inline-flex items-center gap-1.5 bg-[#FAF7F0] text-[#1A1615] hover:bg-white font-ui text-sm font-semibold px-5 py-2.5 rounded-full transition-colors">
            Play the festive round <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};
